export default __webpack_public_path__ + "static/media/bolinhas5.7bfdccdb.svg";